import { Component, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { ExportToExcelCalculateParams, ExportToExcelSettings } from '../../model/ExportToExcelSettings';
import { BooleanTextPipe } from '../../pipes/BooleanTextPipe';
import { StaticDictionaryService } from '../../services/static-dictionary.service';
import { StaticDictionaryCaptionPipe } from '../../pipes/StaticDictionaryCaptionPipe';
import { DurationMinutesPipe } from '../../pipes/DurationMinutesPipe';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-export-to-excel',
  templateUrl: './export-to-excel.component.html',
  styleUrls: ['./export-to-excel.component.scss']
})
export class ExportToExcelComponent {

  constructor(private staticDictionaryService:StaticDictionaryService ,
    private translateService: TranslateService) { }

  booleanTextPipe = new BooleanTextPipe(this.translateService);
  staticDictCaptionPipe = new StaticDictionaryCaptionPipe(this.staticDictionaryService);
  durationMinutesPipe = new DurationMinutesPipe(this.translateService);
  datePipe = new DatePipe("pl-PL");

  calculationFunctionParams : ExportToExcelCalculateParams = {
    staticDictionaryCaptionPipe: this.staticDictCaptionPipe,
    durationMinutesPipe: this.durationMinutesPipe
  }


  @Input() settings:ExportToExcelSettings;
  @Input() set data(value:Array<any>) {
    if(this.excelexport){
      if(value){
        this.excelexport.data = structuredClone(value);
      }
      else{
         this.excelexport.data = value;
      }
      
    }
     
  }
  @Input() showExportButton = true;
  @ViewChild('excelexport') excelexport:ExcelExportComponent;



  processColumns(){
    
    if(!this.excelexport.data){
      return;
    }

    this.settings.columns.map(
      async (c) => {
        if(c.staticDictionaryName){
          
          await this.staticDictionaryService.getStaticDictionary(c.staticDictionaryName).subscribe(
            (items) => {
              const newColumn = c.field + '_dict';
              this.excelexport.data.forEach(
                row => row[newColumn] = items.find(r => r.id == row[c.field])?.value
              )
            }
          )}

          if(c.translateAsBoolean){
           
            this.excelexport.data.forEach(
              row => row[c.field] =  this.booleanTextPipe.transform(row[c.field]));
          }

          if(c.cellOptions?.format == 'yyyy-MM-dd'){
           
            this.excelexport.data.forEach(
              row => row[c.field] =  this.datePipe.transform(row[c.field],'yyyy-MM-dd'));
          }

          if(c.cellOptions?.format == 'yyyy-MM-dd HH:mm'){
           
            this.excelexport.data.forEach(
              row => row[c.field] =  this.datePipe.transform(row[c.field],'yyyy-MM-dd HH:mm'));
          }

          if(c.cellOptions?.format == 'yyyy-MM-dd HH:mm:ss'){
           
            this.excelexport.data.forEach(
              row => row[c.field] =  this.datePipe.transform(row[c.field],'yyyy-MM-dd HH:mm:ss'));
          }

          if(c.calculateValueFn){
           
            this.excelexport.data.forEach(
              async row =>   await c.calculateValueFn(row, this.calculationFunctionParams).subscribe(t1 => row[c.field] = t1));
              // row => row[c.field] =  c.calculateValueFn(row, this.staticDictCaptionPipe)
          }

      });
    }

    save(){
      this.processColumns();
      if(this.settings.autoWidth){
        const options = this.excelexport.workbookOptions();
        options.sheets[0]?.columns.forEach(x => x.autoWidth = true);
      }
     
      this.excelexport.save();
    }

    generateReport( data:Array<any>){
   
      this.excelexport.data = data;
      this.save();
    }
}
